import { Box } from 'grommet';

// Matches the three YouTube URL shapes in the migrated content: youtu.be short
// links, /watch?v= links, and /embed/ links.
const PATTERNS = [
  /^https?:\/\/(?:www\.)?youtu\.be\/([\w-]{6,})/i,
  /^https?:\/\/(?:www\.)?youtube\.com\/watch\?(?:.*&)?v=([\w-]{6,})/i,
  /^https?:\/\/(?:www\.)?youtube\.com\/embed\/([\w-]{6,})/i,
];

/** Returns the video id for a YouTube URL, or null if it isn't one. */
export function youTubeId(url) {
  if (typeof url !== 'string') return null;
  for (const pattern of PATTERNS) {
    const match = url.match(pattern);
    if (match) return match[1];
  }
  return null;
}

/** Responsive 16:9 player. */
export default function YouTubeEmbed({ id, title = 'YouTube video' }) {
  return (
    <Box
      margin={{ vertical: 'medium' }}
      round="xsmall"
      overflow="hidden"
      background="dark-3"
      style={{ position: 'relative', paddingTop: '56.25%' }}
    >
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${id}`}
        title={title}
        loading="lazy"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }}
      />
    </Box>
  );
}
